





import {Component, Vue} from "vue-property-decorator";
import {getFlowCount, getGuideDetail, login, signUp} from "@/services/api"
import store from "@/store";
import JSEncrypt from 'jsencrypt'
import {DisplayInfo} from "@/model/UserInfo";
import {defaultTimezone} from "@/services/config";

@Component({
})
export default class Login extends Vue {
  // 登录表单
  public formData = {
    email: '',
    password: ''
  }
  public signUpData = {
    email: '',
    password: '',
    phone: ''
  }
  public dialogVisible = false;
  public isCheckedTerms = true;
  public isCheckRegistered = true;
  public SuccessVisible = false;
  public signUpTips = '';
  public locationHref: string = location.origin;
  $message: any;
  $route: any;
  $router: any;

  // 法律文件按语言区分路径：en-US → /en/xxx.html，其他 → /xxx.html
  get legalPrefix(): string {
    return this.$i18n.locale === 'en-US' ? '/en' : '';
  }

  created(): void {
    window.location.href = '/cartsee-new/login'
  }

  /**
   * 登录接口调用
   */
  async login(): Promise<void> {
    // 创建加密对象实例
    const encrypt = new JSEncrypt();
    const pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCt+CcQrM1/WAotGUivgWJx5HKRJwKxweHzqvB4bBlNpURXoO3iDPS/RVgw44uAy8IXdWJNQyzHYOTZy4Mlc/Izox1jhFe3mI5whry89kuIRytShg2cvTuR0spuRFbljO4QoOOJELt9tirBb2mvmzyzNMlT3+isUqvC4ThXe5mD4QIDAQAB`;
    encrypt.setPublicKey(pubKey) //设置公钥
    const password = encrypt.encrypt(this.formData.password)|| '';  // 对内容进行加密

    this.formData.email = this.formData.email.replace(/(^\s*)|(\s*$)/g,"");
    if(!this.formData.email) {
      this.$message.error(this.$t('views.login.text_8bf78f9351657528'));
      return;
    }
    if(!this.formData.password) {
      this.$message.error(this.$t('views.login.text_8bf78f9351655bc6'));
      return;
    }
    if(!this.isCheckedTerms) {
      let isCheck = false
      await this.$msgbox({
        title: this.$t('views.login.text_63d0793a') as string,
        message: `<p>${this.$t('views.login.text_62115df296058bfb')}<a target="_blank" style="color: #513EFF" href=${this.locationHref+this.legalPrefix+'/userAgreement.html'}>${this.$t('views.login.text_75286237534f8bae')}</a>${this.$t('views.login.text_548c')}<a target="_blank" style="color: #513EFF" href=${this.locationHref+this.legalPrefix+'/PrivacyPolicy.html'}>${this.$t('views.login.text_969079c1653f7b56')}</a></p>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.login.text_540c610f') as string,
        cancelButtonText: this.$t('views.login.text_53d66d88') as string,
      }).then(()=>{
        this.isCheckedTerms = true
        isCheck = true
      }).catch(() => {
        isCheck = false
      });
      if(!isCheck) {
        return;
      }
    }
    const res1 = await login({ email: this.formData.email, password}, true);
    if (res1.data && res1.data.code === 0) {
      // todo 和displayInfo一样在vuex里设置
      localStorage.setItem('token', res1.data.data.token);
      const displayInfo: DisplayInfo = {name: res1.data.data.name, email: this.formData.email};
      sessionStorage.setItem('sessionDisplayInfo', JSON.stringify(displayInfo));
      localStorage.removeItem('browserGuideShow');
      store.commit('SET_DISPLAY_INFO', displayInfo);
    } else {
      this.$message.error(res1.data.message);
      return
    }

    let defaultPath = '/guide';
    const res2 = await getGuideDetail({},true);
    // todo 和displayInfo一样在vuex里设置
    localStorage.setItem('timezone', res2.data.data.companyInfo.timezone|| defaultTimezone);
    const companyInfo = res2.data.data.companyInfo;
    store.commit('SET_COMPANY_INFO', companyInfo);
    if (res2.data.data.nextStep === -1) {
      defaultPath = '/home';
      const res3 = await getFlowCount({}, true);
      if(res3.data.data === 0) {
        defaultPath = '/account/settings';
        store.commit('SET_FLOW_COUNT', res3.data.data);
      }
    } else {
      store.commit('SET_TEMPLATE_INFO', res2.data.data);
    }

    const redirect: any = defaultPath === '/guide'? defaultPath : (this.$route.query.redirect || defaultPath);
    this.$router.replace(redirect);
  }

  /**
   * 注册
   */
  async signUp() {
    if(!this.signUpValidator()) {
      return;
    }
    if(!this.isCheckRegistered) {
      let isCheck = false
      await this.$msgbox({
        title: this.$t('views.login.text_63d0793a') as string,
        message: `<p>${this.$t('views.login.text_62115df296058bfb')}<a target="_blank" style="color: #513EFF" href=${this.locationHref+this.legalPrefix+'/userAgreement.html'}>${this.$t('views.login.text_75286237534f8bae')}</a>${this.$t('views.login.text_548c')}<a target="_blank" style="color: #513EFF" href=${this.locationHref+this.legalPrefix+'/PrivacyPolicy.html'}>${this.$t('views.login.text_969079c1653f7b56')}</a></p>`,
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.login.text_540c610f') as string,
        cancelButtonText: this.$t('views.login.text_53d66d88') as string,
      }).then(()=>{
        this.isCheckRegistered = true
        isCheck = true
      }).catch(() => {
        isCheck = false
      });
      if(!isCheck) {
        return;
      }
    }
    signUp({
      ...this.signUpData,
      ...(this.$route.query.integrationId === '31' && {
        integrationId: this.$route.query.integrationId,
        authorize_token_url: this.$route.query.authorize_token_url,
        code: this.$route.query.code
      })
    }, true).then(res => {
      this.signUpData = {
        email: '',
        password: '',
        phone: ''
      }
      this.SuccessVisible = true;
    }).catch(() => {
    })
  }

  signUpValidator() {
    if(!this.signUpData.email) {
      this.signUpTips = this.$t('views.login.text_8bf78f93516590ae') as string;
      return false;
    }
    if(!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(this.signUpData.email)) {
      this.signUpTips = this.$t('views.login.text_8bf78f9351656b63') as string;
      return false;
    }
    if(!this.signUpData.phone) {
      this.signUpTips = this.$t('views.login.text_8bf78f9351657535') as string;
      return false;
    }
    if(!this.signUpData.password) {
      this.signUpTips = this.$t('views.login.text_8bf78f9351655bc6') as string;
      return false;
    }
    if(this.signUpData.password.length < 8) {
      this.signUpTips = this.$t('views.login.text_5bc6780181f35c11') as string;
      return false;
    }
    this.signUpTips = '';
    return true;
  }
}

